<template>
  <div class="bgs">
    <Header></Header>
    <!-- 轮播图 -->
    <div class="banner">
      <a :href="Advertisement_img.url" target="_blank">
        <img :src="Advertisement_img.picture" alt="">
      </a>
    </div>
    <!-- 中间 -->
    <div class="main">
      <div class="main_left">
        <!-- 行业专家 -->
        <div class="main_left_top">
          <div class="titles">- 行业专家 -</div>
          <ul class="lists">
            <li class="list" v-for="(item,index) in expert_list" @click="Go_AuthorsHome(item.uid)" :key="index">
              <img :src="item.headimg" alt="">
              <div class="list_name">{{item.organization_name}}</div>
              <div class="list_content">{{item.organization_desc}}</div>
            </li>
          </ul>
        </div>
        <!-- 专业机构 -->
        <div class="main_left_top">
          <div class="titles">- 专业机构 -</div>
          <ul class="lists">
            <li class="list" v-for="(item,index) in Professional_list" @click="Go_AuthorsHome(item.uid)" :key="index">
              <img :src="item.headimg" alt="">
              <div class="list_name">{{item.organization_name}}</div>
              <div class="list_content">{{item.organization_desc}}</div>
            </li>
          </ul>
        </div>
        <!-- 最新加入 -->
        <div class="main_left_top">
          <div class="titles">- 最新加入 -</div>
          <ul class="listss">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide list" v-for="(item,index) in New_list"  @click="Go_AuthorsHome(item.uid)" :key="index">
                  <img :src="item.headimg" alt="">
                  <div class="list_name">{{item.organization_name}}</div>
                  <div class="list_content">{{item.organization_desc}}</div>
                </div>
              </div>
            </div>
          </ul>
        </div>
      </div>
      <div class="main_right">
        <div class="main_right_list">
          <div class="main_right_list_title">
            <div class="shugang"></div>
            <div>最新发布</div>
          </div>
          <div class="main_right_list_l" v-for="(item,index) in New_Release" @click="Go_Relevant(item.info,item.id)"
            :key="index">
            <div class="yuandian">●</div>
            <div class='titless'>
              {{item.info==1?item.patent_profile:item.info==2?item.report_profile:item.info==3?item.title:''}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import Axios from "axios";
import Swiper from "swiper";
export default {
   metaInfo(){
     return{
        title: '智库_驱动中国研究院',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      lists: [1, 2, 3, 4],
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      expert_list: [], //行业专家
      Professional_list: [], //专业机构
      New_list: [],
      New_Release:[],
      Advertisement_img:'', //广告图
    };
  },
  mounted() {
    this.Swiper();
    this.IndustryExperts(); //行业专家
    this.ProfessionalInstitutions(); //专业机构
    this.New_List(); //最新加入
    this.New_release();   //最新发布
    this.advertisement_img();
  },
  methods: {
    // 最新发布跳转详情
    Go_Relevant(info, id){
      if (info == 1) {
        this.$router.push({ name: "PatentDetails", query: { id: id } });
      } else if (info == 2) {
        this.$router.push({ name: "ResearchReportDetails", query: { id: id } });
      } else {
        this.$router.push({ name: "InformationDetails", query: { id: id } });
      }
    },
    // 广告图
    advertisement_img(){
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/img_zhiKu",
        params: {},
      }).then((res) => {
        ////console.log(res);
        this.Advertisement_img = res.data.data;
      });
    },
    // 最新发布
    New_release(){
        Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/personal_list",
        params: {},
      }).then((res) => {
        ////console.log(res);
        this.New_Release = res.data.data;
      });
    },
    // 跳转个人主页
    Go_AuthorsHome(uid){
        this.$router.push({ name: "AuthorsHome",query: { id: uid }});
    },
    // 行业专家
    IndustryExperts() {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/patent_user",
        params: {},
      }).then((res) => {
        ////console.log(res.data.data);
        this.expert_list = res.data.data;
      });
    },

    // 专业机构
    ProfessionalInstitutions() {
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/report_user",
        params: {},
      }).then((res) => {
        ////console.log(res.data.data);
        this.Professional_list = res.data.data;
      });
    },

    // 最新加入
    New_List() {
      var that=this;
      Axios({
        method: "get",
        url: "https://researchadmin.qudong.com/api/zhiKu_list",
        params: {},
      }).then((res) => {
        ////console.log(res);
        this.New_list = res.data.data;
        that.$nextTick(()=>{
          var mySwiper = new Swiper(".swiper-container", {
          speed: 2000,
          autoplay: {
            delay: 30,
            disableOnInteraction: false,
            // waitForTransition: false,
          },
          loop: true,
          slidesPerView: "auto",
          queueEndCallbacks: true,
          centeredSlides: true, //
          slidesPerView: 4,
          spaceBetween: 30,
          observer: true,
          observerParents: true,
          centeredSlides: true,
          watchSlidesProgress: true,
          on: {
            setTranslate: function () {
              var slides = this.slides;
              for (var i = 0; i < slides.length; i++) {
                var slide = slides.eq(i);
                var progress = slides[i].progress;
                //slide.html(progress.toFixed(2)); 看清楚progress是怎么变化的
                // slide.css({'opacity': '','background': ''});slide.transform('');//清除样式
                // if(effect == 1){
                slide.transform("scale(" + (1 - Math.abs(progress) / 8) + ")");
                // }else if(effect == 2){
                // slide.css('opacity',(1-Math.abs(progress)/6));
                // slide.transform('translate3d(0,'+ Math.abs(progress)*20+'px, 0)');
                // }
                // else if(effect == 3){
                // slide.transform('rotate('+ progress*30+'deg)');
                // }else if(effect == 4){
                // slide.css('background','rgba('+ (255 - Math.abs(progress)*20) +','+ (127 + progress*32) +',' + Math.abs(progress)*64 + ')');
                // }
              }
            },
            setTransition: function (transition) {
              for (var i = 0; i < this.slides.length; i++) {
                var slide = this.slides.eq(i);
                slide.transition(transition);
              }
            },
          },
        });
        //鼠标覆盖停止自动切换
        mySwiper.el.onmouseover = function () {
          mySwiper.autoplay.stop();
        };

        //鼠标离开开始自动切换
        mySwiper.el.onmouseout = function () {
          mySwiper.autoplay.start();
        };
      })
      });
    },

    // 轮播
    Swiper() {
      var that = this;
      // setTimeout(() => {
      
      // }, 30);
    },
  },
};
</script>

<style scoped>
.bgs {
  background: #f5f7f9;
}
.banner {
  width: 100%;
  height: 300px;
}
.banner img {
  width: 100%;
  height: 100%;
  cursor: pointer;
  object-fit: cover;
}
.main {
  width: 1200px;
  margin: 20px auto 40px;
  display: flex;
}
.main_left {
  width: 860px;
  /* background:#fff; */
  margin-right: 20px;
}
.main_right {
  width: 320px;
  /* background:#fff; */
}
.main_left_top {
  width: 860px;
}
.titles {
  width: 194px;
  height: 29px;
  font-size: 30px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  margin: 35px auto;
}
.lists {
  display: flex;
}
.listss {
  display: flex;
  background: #fff;
}
.list {
  cursor: pointer;
  width: 176px;
  padding: 15px;
    margin-right:12px;
  background: #fff;
  /* margin-right: 12px; */
}
.list img {
  width: 176px;
  height: 176px;
  margin:0 auto;
  object-fit: cover;
}
.list_name {
  margin: 20px 0 12px;
  text-align: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
.list_content {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height:24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  text-align: center;
  -webkit-box-orient: vertical;
}
.main_right_list {
  width: 320px;
  height: 430px;
  margin-top: 21px;
  background: #fff;
}
.main_right_list .shugang {
  width: 4px;
  height: 28px;
  background: #3463db;
  margin-right: 10px;
}
.main_right_list_title {
  width: 320px;
  height: 49px;
  display: flex;
  align-items: center;
  color: #3463db;
  border-bottom: 1px solid #e8e8e8;
}
.main_right_list_l {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  cursor: pointer;
}
.main_right_list_l .yuandian {
  margin-right: 10px;
  color: #999999;
}
.titless {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #666666;
  -webkit-box-orient: vertical;
}
</style>